module.exports = __webpack_public_path__ + "img/inter_wps.0ce3592b.svg";